// extracted by mini-css-extract-plugin
module.exports = {"imgUrl":"InvoiceModal_imgUrl__2PuPE"};